
export const RECUR_REMINDER_NO_REPEAT_ID = 4
export const RECUR_REMINDERS_DAILY = {
  id: 1,
  key: 'Daily'
}

export const RECUR_REMINDERS = [
  RECUR_REMINDERS_DAILY,
  {
    id: 2,
    key: 'Weekly'
  },
  {
    id: 3,
    key: 'Monthly'
  }
]

export const RECUR_RADIO_NEVER = {
  id: 1,
  key: 'Never'
}

export const RECUR_RADIO_ON = {
  id: 2,
  key: 'On'
}

export const RECUR_RADIO_LIST = [
  RECUR_RADIO_NEVER,
  RECUR_RADIO_ON
]

export const REMINDER_STATUS = {
  PROJECT: 1,
  REQUEST: 2
}



// WEBPACK FOOTER //
// ./src/constants/recurReminders.js